import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useId, useComputed$, useSignal, useTask$, useContextProvider, Slot } from "@builder.io/qwik";
import { HCollapsible } from "../collapsible/collapsible.qwik.mjs";
import { accordionContextId, accordionItemContextId } from "./accordion-context.qwik.mjs";
import { isServer } from "@builder.io/qwik/build";
const HAccordionItem = component$(({ id, _index, value, open, ...props }) => {
  const context = useContext(accordionContextId);
  const localId = useId();
  const itemId = id ?? localId + "-item";
  const localIndexSig = useComputed$(() => {
    return _index ?? -1;
  });
  const isOpenSig = useSignal(context.initialIndex === localIndexSig.value);
  const initialLoadSig = useSignal(true);
  const triggerRef = useSignal(null);
  useTask$(function internalState({ track }) {
    track(() => context.selectedIndexSig.value);
    if (context.isMultipleSig.value || isServer)
      return;
    if (context.selectedIndexSig.value !== localIndexSig.value) {
      isOpenSig.value = false;
    } else {
      if (!initialLoadSig.value && value && context.onChange$) {
        context.onChange$(value);
      }
      if (!context.givenValueSig)
        return;
      context.givenValueSig.value = value ?? null;
    }
  });
  useTask$(function givenReactiveValue({ track }) {
    if (!context.givenValueSig)
      return;
    track(() => context.givenValueSig?.value);
    if (context.givenValueSig?.value === value) {
      isOpenSig.value = true;
      context.selectedIndexSig.value = localIndexSig.value;
    } else {
      isOpenSig.value = false;
    }
  });
  useTask$(({ track }) => {
    track(() => localIndexSig.value);
    context.triggerRefsArray.value[localIndexSig.value] = triggerRef;
    track(() => isOpenSig.value);
    if (isOpenSig.value) {
      context.selectedIndexSig.value = localIndexSig.value;
    }
  });
  useTask$(() => {
    initialLoadSig.value = false;
  });
  const itemContext = {
    isOpenSig,
    localIndexSig,
    triggerRef
  };
  useContextProvider(accordionItemContextId, itemContext);
  return /* @__PURE__ */ jsx(HCollapsible, {
    triggerRef,
    "bind:open": open ? void 0 : isOpenSig,
    open: context.isMultipleSig.value ? open : void 0,
    id: itemId,
    disabled: context.disabled || props.disabled,
    collapsible: context.collapsible,
    accordionItem: true,
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HAccordionItem
};
